import styles from './MarketHome.module.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useLazyReadHostServiceListByMonitorIdQuery, useReadHostServiceListByMonitorIdQuery } from 'services/hostService/qhostService'
import { StartPropertySpyDialog } from './presentationals/StartPropertySpyDialog'
import { useStartSpyHostServiceMutation, useStopSpyHostServiceMutation } from 'services/propertySpy'
import classNames from 'classnames'
import { ApplicationMainTabs } from 'shared/widgets/ApplicationMainTabs'
import { useReadSpyCurrentLaunchDecorator } from 'shared/hooks/useReadSpyCurrentLaunchDecorator/useReadSpyCurrentLaunchDecorator'
import { useReadMonitorRunResultGroupedByMonitorIdQuery } from 'services/monitorRunResult'
import { useLazyReadMonitorRunResultGroupedByMonitorIdQuery } from 'services/monitorRunResult/qmonitorRunResult'
import { useCreateSpy } from 'shared/hooks/useCreateSpy'
import { WidgetsContainer } from './presentationals/WidgetsContainer'
import { LoadingDialog } from './presentationals/LoadingDialog'
import { selectContextLocationSearchString, setMode } from 'store/applicationSlice'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { useCreateOrReadSpy } from 'shared/hooks/useCreateOrReadSpy'
import { LocationHint } from './presentationals/LocationHint/LocationHint'
import { MapWithCompetitors } from './presentationals/MapWithCompetitors'
import { DefaultContextControl } from 'shared/widgets/DefaultContextControl'
import { useContextLocation } from 'shared/hooks/useContextLocation'
import { useContextSpyLaunchSettings } from 'shared/hooks/useContextSpyLaunchSettings1'
import { useContextFilters } from 'shared/hooks/useContextFilters'
import { CreateOrReadSpyParams } from 'shared/hooks/useCreateOrReadSpy/types'
import { useContextManager } from 'shared/hooks/useContextManager'
import { useContextSpyId } from 'shared/hooks/useContextSpyId'
import { DefaultContextControlContainer } from 'shared/containers/DefaultContextControl/DefaultContextControlContainer'
import { useEventListener } from 'shared/providers/EventBusProvider'

interface MarketHomeProps{
}

export const MarketHome = (props: MarketHomeProps): JSX.Element => {
    const {
    } = props

    const [startSpyHostService] = useStartSpyHostServiceMutation()
    const [stopSpyHostService] = useStopSpyHostServiceMutation()
    const [readHostService] = useLazyReadHostServiceListByMonitorIdQuery()
    const [startPropertySpyDialogOpen, setStartPropertySpyDialogOpen] = useState<boolean>(false)
    const [marketSpyIdForSearchingHostServiceList, setMarketSpyIdForSearchingHostServiceList] = useState<number | undefined>(undefined)
    const [locationListMarketSpyId, setLocationListMarketSpyId] = useState<number | undefined>(undefined)
    const [readHostServiceListByMonitorIdQueryData, setReadHostServiceListByMonitorIdQueryData] = useState<any>(undefined)
    const [updateNeeded, setUpdateNeeded] = useState<any>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [searchNeeded, setSearchNeeded] = useState<boolean>(false)
    const {createOrReadSpy} = useCreateOrReadSpy()
    const dispatch = useAppDispatch()

    /////////////////////////////////////

    const locationString: any = useAppSelector(selectContextLocationSearchString)

    const {
        selectContextSpyId,
        setContextSpyId
    } = useContextSpyId()

    const {
        selectContextLocation,
        setContextLocation
    } = useContextLocation()

    const {
        selectContextSpyLaunchSettings,
        setContextSpyLaunchSettings
    } = useContextSpyLaunchSettings()

    const {
        selectContextFilters,
        setContextFilters
    } = useContextFilters()

    const search = async (params: any) => {    
        if (params.location === undefined && selectContextLocation === undefined){
            return
        }   

        const createOrReadSpyParams: CreateOrReadSpyParams = {
            location: params.location || selectContextLocation,
            filters: params.filters || selectContextFilters,
            launchSettings: params.spyLaunchSettings || selectContextSpyLaunchSettings
        }

        const createOrReadSpyResult: any = await createOrReadSpy(createOrReadSpyParams)
        const createOrReadSpySpyId =  createOrReadSpyResult?.id
        setContextSpyId(createOrReadSpySpyId)   
    }
    //////////////////////////
    const spyId = selectContextSpyId
    useEventListener('defaultContextControl:search', (params) => {
       search(params)
    })

    useEventListener('defaultContextControl:filtersChange', (params) => {
        search(params)
    })

    useEventListener('defaultContextControl:spyLaunchSettingsChange', (params) => {
        search(params)
    })

    const handleStartPropertySpyDialogOk = (event: any) => {
        setStartPropertySpyDialogOpen(false)
    }

    const handleStartPropertySpyDialogClose = (event: any) => {
        setStartPropertySpyDialogOpen(false)
    }

    const [readMonitorRunResultGroupedByMonitorId] = useLazyReadMonitorRunResultGroupedByMonitorIdQuery()
    const [createSpy] = useCreateSpy()  
    const [readMonitorRunResultGroupedByMonitorIdQueryParams, setReadMonitorRunResultGroupedByMonitorIdQueryParams] = useState<any>({
        monitorId: spyId || undefined
    })
    
    const [readMonitorRunResultGroupedByMonitorIdQueryOptions, setReadMonitorRunResultGroupedByMonitorIdQueryOptions] = useState<any>({
        skip: true
    })

    const {
        data: readSpyCurrentLaunchDecoratorData,
        previousData: readSpyCurrentLaunchDecoratorPreviousData,
        setParams: setReadSpyCurrentLaunchDecoratorParams,
        setOptions: setReadSpyCurrentLaunchDecoratorOptions,
    } = useReadSpyCurrentLaunchDecorator()

    const {
        data: readMonitorRunResultGroupedByMonitorIdData,
        isLoading: readMonitorRunResultGroupedByMonitorIdIsLoading,
        isFetching: readMonitorRunResultGroupedByMonitorIdIsFetching,
        isError: readMonitorRunResultGroupedByMonitorIdIsError,
        refetch: readMonitorRunResultGroupedByMonitorIdQueryRefetch
    } = useReadMonitorRunResultGroupedByMonitorIdQuery(
        readMonitorRunResultGroupedByMonitorIdQueryParams,
        readMonitorRunResultGroupedByMonitorIdQueryOptions
    )

    const competitorsRootClasses = classNames(styles.MarketHome__Root, {
        [styles.MarketHome__Root]: locationListMarketSpyId !== undefined,
    })

    const startReadSpyStatus = async (spyId: number) => {
        setReadSpyCurrentLaunchDecoratorParams({
            spyId: spyId
        })

        setReadSpyCurrentLaunchDecoratorOptions({
            skip: false,
        })
    }

    const stopReadSpyStatus = async () => {
        setReadSpyCurrentLaunchDecoratorOptions({
            skip: true
        })
    }

    useEffect(() => {
        const handle = () => {
            if (readSpyCurrentLaunchDecoratorData?.status === 2){
                setUpdateNeeded(true)
                return
            }

            if (readSpyCurrentLaunchDecoratorData?.status === 0 || readSpyCurrentLaunchDecoratorData?.status === 1){
                if (readSpyCurrentLaunchDecoratorData.completed > readSpyCurrentLaunchDecoratorPreviousData?.completed ) {
                    setUpdateNeeded(true)
                    return
                }

                if (readSpyCurrentLaunchDecoratorPreviousData?.completed > 0 && readSpyCurrentLaunchDecoratorData?.completed === 0){
                    setUpdateNeeded(true)
                    return
                }

                if (readSpyCurrentLaunchDecoratorPreviousData?.completed > 0 && readSpyCurrentLaunchDecoratorData?.completed === null){
                    setUpdateNeeded(true)
                    return
                }
            }
        }

        handle()
    }, [
        readSpyCurrentLaunchDecoratorData
    ])

    useEffect(() => {
        const handle = async () => {
            if (spyId === undefined){
                stopReadSpyStatus()
                return
            }

            startReadSpyStatus(spyId)
            setIsLoading(true)

            const readMonitorRunResultGroupedByMonitorIdResult = await readMonitorRunResultGroupedByMonitorId({
                monitorId: spyId
            })

            if (readMonitorRunResultGroupedByMonitorIdResult?.data?.count > 0){
                setUpdateNeeded(true)
            }
        }

        handle()
    }, [
        spyId
    ])

    useEffect(() => {
        setUpdateNeeded(true)
    }, [
        selectContextFilters
    ])

    // const { setTimeoutSafe } = useTimeout()

    useEffect(() => {
        if (updateNeeded === true){
            if (spyId === undefined){
                return
            }

            if (spyId !== undefined && readMonitorRunResultGroupedByMonitorIdIsLoading === true){
                setIsLoading(true)
            }

            setTimeout(() => {
                setReadMonitorRunResultGroupedByMonitorIdQueryParams({
                    monitorId: spyId,
                    //...selectContextFilters
                })

                setReadMonitorRunResultGroupedByMonitorIdQueryOptions({
                    skip: !(updateNeeded && spyId !== undefined)
                })
                

                if (spyId !== undefined && readMonitorRunResultGroupedByMonitorIdIsLoading !== false){
                    readMonitorRunResultGroupedByMonitorIdQueryRefetch()
                }
                
                setUpdateNeeded(false)
                return
            }, 3000)
        }
    }, [
        updateNeeded,
        spyId
    ])

    useEffect(()=> {
        if (readMonitorRunResultGroupedByMonitorIdData === undefined){
            return
        }

        setIsLoading(false)
    }, [
        readMonitorRunResultGroupedByMonitorIdData 
    ])

    useEffect(() => {
        dispatch(setMode('market'))
    }, [])

    useEffect(() => {
        setIsLoading(false)
    }, [
        readMonitorRunResultGroupedByMonitorIdIsError
    ])

    useEffect(() => {
        if (readMonitorRunResultGroupedByMonitorIdIsFetching === false){
            setIsLoading(false)
        }

    }, [
        readMonitorRunResultGroupedByMonitorIdIsFetching
    ])

    const render = useCallback(() => {
            if (spyId === undefined){
            return (
                <div className={styles.MarketHome__MapContainer}>
                    <MapWithCompetitors 
                        onCloseDetailWindow={() => {}}
                        onStartPropertySpy={() => {}}
                        onStopPropertySpy={() => {}}
                        onMarkerClick={() => {}}
                    />
                    <div className={styles.MarketHome__LocationHintContaner}>
                        <LocationHint/>
                    </div>
                </div>
            ) 
        }

        if (readMonitorRunResultGroupedByMonitorIdData === undefined || readMonitorRunResultGroupedByMonitorIdIsLoading === true){
            return (
                <div className={styles.MarketHome__MapContainer}>
                    <MapWithCompetitors
                        onCloseDetailWindow={() => {}}
                        onStartPropertySpy={() => {}}
                        onStopPropertySpy={() => {}}
                        onMarkerClick={() => {}}
                    />
                </div>
            ) 
        }  

        return (
                <WidgetsContainer 
                    hostServices={readHostServiceListByMonitorIdQueryData?.list}
                    hostServicesCount={readHostServiceListByMonitorIdQueryData?.count}
                    summary={readMonitorRunResultGroupedByMonitorIdData}
                    spyId={spyId}    
                    filter={selectContextFilters}
                />
        )
    }, [
        readMonitorRunResultGroupedByMonitorIdData,
        spyId
    ])

    return (
        <div className={competitorsRootClasses}>
            <ApplicationMainTabs />
            <div className={styles.MarketHome__ContentContainer}>
                <div className={styles.MarketHome__Content}>
                    {
                        render()
                    }
                    
                </div>
                <StartPropertySpyDialog
                    open={startPropertySpyDialogOpen}
                    onClose={handleStartPropertySpyDialogClose}
                    onOk={handleStartPropertySpyDialogOk}
                />   
                <LoadingDialog 
                    open={isLoading}
                />
            </div>
            <DefaultContextControlContainer
            />
        </div>    
    )
}